'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'supportTool', 'SupportToolService', 'StatusService',
    function ($scope, $modalInstance, supportTool, SupportToolService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.supportTool = angular.copy(supportTool);

            if (supportTool == null || angular.equals({}, supportTool) || supportTool.id == null) {
                $scope.title = "Создание инструмента поддержки инвестиционных проектов";
            } else {
                $scope.title = "Редактирование инструмента поддержки инвестиционных проектов \"" + $scope.supportTool.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.supportTool.status) {
                    $scope.supportTool.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.supportTool);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                SupportToolService.api.isUniqueName({name: name}, {id: $scope.supportTool.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];